import { FC, useContext } from 'react';
import { Typography } from 'src/components/common/Typography';
import { FooterContext } from 'src/constructors/Footer/FooterConstructor';
import { reachTextParser } from 'src/helpers/utils';
import './styles.scss';

type Props = {
  settings: {
    priority: number;
    styles: Styles;
  };
};
const OperatorBlock: FC<Props> = ({ settings }) => {
  const { styles } = settings;
  const footerConfigs = useContext(FooterContext);

  return (
    <Typography className="textBlock_wrapper" variant={'h6'} style={styles}>
      <p>
        {footerConfigs?.content?.businessActivityInfo
          ? reachTextParser(footerConfigs.content.businessActivityInfo)
          : 'BUSINESS_ACTIVITY_INFO'}
      </p>
    </Typography>
  );
};
export default OperatorBlock;
